import { useEffect, useState } from "react";
import {
  getIncomeExpenseEntries,
  rehydrateIncomeExpenseEntries,
  setAllIncomeExpenseEntries,
  subscribeIncomeExpenseEntries,
} from "../lib/incomeExpenseStore";

export function useIncomeExpense() {
  const [entries, setEntries] = useState(getIncomeExpenseEntries());

  useEffect(() => {
    void rehydrateIncomeExpenseEntries();

    return subscribeIncomeExpenseEntries(() => {
      setEntries(getIncomeExpenseEntries());
    });
  }, []);

  return {
    entries,
    setAllEntries: setAllIncomeExpenseEntries,
  };
}